import { render, staticRenderFns } from "./CashierDesk.vue?vue&type=template&id=297aee50&scoped=true&"
import script from "./CashierDesk.vue?vue&type=script&lang=js&"
export * from "./CashierDesk.vue?vue&type=script&lang=js&"
import style0 from "./CashierDesk.vue?vue&type=style&index=0&id=297aee50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297aee50",
  null
  
)

export default component.exports